const state = {
  msg: "这是我的状态"
};
const mutations = {
  ADD_MSGs: (state, msg) => {
    state.msg = msg;
  }
};
const actions = {
  addErrorlog({ commit }, log) {
    setTimeout(function() {
      commit("ADD_MSGs", log);
    }, 2000);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js